import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = () => ({
  activeTrail: [],
  companyList: [],
  groupList: [],
  eventsList: [],
  userList: [],
  activeIndex: 0,
  orders: {
    bookingsToday: [],
    status: "pending",
    count: 0
  },
  ordersTotalSales: 0,
  optionsList: [],
  emailNotificationsLists: [],
  schemeList: [],
  filters: {},
  reportHistory: 0,
  stripeCheckout: {}
});

export default {
  state,
  actions,
  getters,
  mutations
};
